module.exports = __webpack_public_path__ + "img/kf.ce54c236.png";